import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setBatchInvoice,
  setBillingActivityLoader,
  setBillingActivityLogList,
  setBillingBatchList,
  setBillingInvoiceActivityLog,
  setBillingInvoiceDetails,
  setIsBillingLoad
} from 'src/store/modules/actions/billing'

import {
  BILLING_BATCH_QUEUED_MESSAGE,
  DATE_TIME_FORMAT_FOR_SERVER,
  EXPORT_BATCH_PDF,
  EXPORT_BATCH_XLS,
  GET_BILLING_ACTIVITY_LOG
} from 'src/constants'
import company from 'src/services/@core/API/routes/company'
import { showSuccessModal } from 'src/services/dialogs'
import { exportReport } from 'src/utils/Functions'

export const getBillingActivityLog = (query) => async (dispatch) => {
  dispatch(setBillingActivityLoader(true))
  try {
    const { items = [], meta = {} } = await httpClient.request({
      method: 'get',
      url: {
        pathname: GET_BILLING_ACTIVITY_LOG,
        query
      }
    })

    dispatch(setBillingActivityLogList(items))
    return meta
  } catch (err) {
    catchError(err)
  } finally {
    dispatch(setBillingActivityLoader(false))
  }
}

export const postNewBillingBatch = (payload, push) => async (dispatch) => {
  dispatch(setIsBillingLoad(true))

  try {
    await company.postNewBillingBatch(payload)
    push('/actions/batch-grid')
    showSuccessModal({
      title: 'Success',
      content: BILLING_BATCH_QUEUED_MESSAGE,
      centered: true,
      keyboard: false
    })
  } catch (err) {
    catchError(err)
  } finally {
    dispatch(setIsBillingLoad(false))
  }
}

export const getBillingBatch = (query) => async (dispatch) => {
  dispatch(setBillingActivityLoader(true))
  try {
    const { items = [], meta = {} } = await company.getBillingBatch({ query })

    dispatch(setBillingBatchList(items))
    return meta
  } catch (err) {
    catchError(err)
  } finally {
    dispatch(setBillingActivityLoader(false))
  }
}

export const getBatchInvoice = (config) => async (dispatch) => {
  dispatch(setBillingActivityLoader(true))
  try {
    const { items = [], meta = {} } = await company.getBatchInvoice(config)

    dispatch(setBatchInvoice(items))
    return meta
  } catch (err) {
    catchError(err)
  } finally {
    dispatch(setBillingActivityLoader(false))
  }
}

export const getBillingInvoiceDetails = (config) => async (dispatch) => {
  dispatch(setBillingActivityLoader(true))
  try {
    const {
      items = [],
      meta = {},
      header = {}
    } = await company.getBillingInvoiceDetails(config)

    dispatch(setBillingInvoiceDetails(header))
    dispatch(setBillingInvoiceActivityLog(items))
    return meta
  } catch (err) {
    catchError(err)
  } finally {
    dispatch(setBillingActivityLoader(false))
  }
}

export const unbillInvoice =
  (params, fetchBatchInvoice) => async (dispatch) => {
    const config = {
      params
    }
    dispatch(setBillingActivityLoader(true))
    try {
      await company.unbillInvoice(config)
      await dispatch(setBillingActivityLoader(false))
      fetchBatchInvoice()
    } catch (err) {
      catchError(err)
    }
  }

export const exportBatchXls =
  (uuid = null) =>
  async () => {
    const config = {
      pathname: EXPORT_BATCH_XLS,
      params: {
        uuid
      }
    }

    await exportReport(
      config,
      `batch_${moment().format(DATE_TIME_FORMAT_FOR_SERVER)}.xls`
    )
  }

export const exportBatchPdf = (uuid) => async () => {
  try {
    const { data, headers } = await httpClient.request({
      method: 'get',
      url: {
        pathname: EXPORT_BATCH_PDF,
        params: {
          uuid
        }
      },
      isDownload: true
    })
    const fileName = headers['content-disposition'].slice(
      headers['content-disposition'].indexOf('filename') + 9
    )
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.pdf`)
    document.body.appendChild(link)
    link.click()
  } catch (err) {
    catchError(err)
  }
}
